import React, { useEffect, useRef, useState } from "react";
import { useRegistrationForm } from "../../customHooks/RegistrationForm/useRegistrationForm";
import "./RegistrationForm.css";
import { AiOutlineInfoCircle } from "react-icons/ai";
import logo from "../../assets/images/iAugment-logo-color.png";

export const RegistrationForm = ({ apiKey }) => {
  const {
    brandLogo,
    brandName,
    username,
    email,
    setBrandName,
    setUsername,
    setEmail,
    handleSubmit,
    handleLogoUpload,
    handleBlur,
    errors,
    loading,
    otp,
    setOtp,
    sendOtp,
    verifyOtp,
    otpSent,
    otpVerified,
    otpError,
    sendLoader,
    verifyLoader,
  } = useRegistrationForm({ apiKey });

  return (
    <>
      <div className="Darkbg">
        <div className="FirstGackground">
          <div className="MainLogoTop">
            <img src={logo} alt="Logo" />
          </div>

          <div className="position-relative MobileView">
            {" "}
            <div className="col-lg-7 log">
              <div className="LoginHeader">
                <b>Welcome to Virtual Try-On!</b>
                <br />
                Set up your VTO store by providing the required details. This is
                essential for syncing your products with the VTO CMS, allowing
                you to make them VTO-ready.
              </div>
              <div className="mt-2">
                <h2>Create VTO Store</h2>
                <form className="registration-form" onSubmit={handleSubmit}>
                  <div className="form-group">
                    <label htmlFor="brand-name">Brand Name</label>
                    <input
                      type="text"
                      id="brand-name"
                      placeholder="Enter your brand name"
                      value={brandName}
                      onChange={(e) => setBrandName(e.target.value)}
                      onBlur={(e) => handleBlur("brandName", e.target.value)}
                    />
                    {errors.brandName && (
                      <p className="error-message">{errors.brandName}</p>
                    )}
                  </div>

                  <div className="form-group">
                    <label htmlFor="brand-logo">
                      Brand Logo
                      <div className="tooltip-container">
                        <AiOutlineInfoCircle className="info-icon" />
                        <div className="tooltip-text">
                          <p>
                            <strong>Brand Logo Requirements:</strong>
                          </p>
                          <ul>
                            <li>
                              ✅ Use <b>PNG or JPG</b> format
                            </li>
                            <li>
                              ✅ Minimum size: <b>300x300px</b>
                            </li>
                            <li>
                              ✅ Recommended size: <b>500x500px+</b>
                            </li>

                            <li>✅ File size should be less than 2MB</li>
                          </ul>
                        </div>
                      </div>
                    </label>
                    <div className="">
                      <div className="file-upload col-7">
                        <span className="upload-text">Click to Upload</span>
                        <input
                          type="file"
                          id="brand-logo"
                          accept="image/*"
                          onChange={handleLogoUpload}
                        />
                      </div>

                      <div className="col-5">
                        {brandLogo && (
                          <img
                            src={URL.createObjectURL(brandLogo)}
                            alt="Brand Logo"
                            className="logo-preview"
                          />
                        )}
                      </div>
                    </div>

                    {errors.brandLogo && (
                      <p className="error-message">{errors.brandLogo}</p>
                    )}
                  </div>

                  <div className="form-group">
                    <label htmlFor="username">Username</label>
                    <input
                      type="text"
                      id="username"
                      placeholder="Choose a username"
                      value={username}
                      onChange={(e) => setUsername(e.target.value)}
                      onBlur={(e) => handleBlur("username", e.target.value)}
                    />
                    {errors.username && (
                      <p className="error-message">{errors.username}</p>
                    )}
                  </div>

                  <div className="form-group">
                    <label htmlFor="email">Email</label>
                    <input
                      type="email"
                      id="email"
                      placeholder="Enter your email"
                      value={email}
                      onChange={(e) => setEmail(e.target.value)}
                      onBlur={(e) => handleBlur("email", e.target.value)}
                      disabled={otpVerified}
                      className={otpVerified ? "disabled" : ""}
                    />
                    {errors.email && (
                      <p className="error-message">{errors.email}</p>
                    )}
                  </div>
                  <div className="otp-section">
                    {!otpSent && (
                      <>
                        {sendLoader ? (
                          <button className="otp-button" disabled>
                            <svg
                              className="animate-spin h-5 w-5 mr-3 text-white"
                              xmlns="http://www.w3.org/2000/svg"
                              fill="none"
                              viewBox="0 0 24 24"
                            >
                              <circle
                                className="opacity-25"
                                cx="12"
                                cy="12"
                                r="10"
                                stroke="currentColor"
                                strokeWidth="4"
                              ></circle>
                              <path
                                className="opacity-75"
                                fill="currentColor"
                                d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
                              ></path>
                            </svg>
                          </button>
                        ) : (
                          <button
                            type="button"
                            className="otp-button"
                            onClick={sendOtp}
                            disabled={!email}
                          >
                            Send OTP
                          </button>
                        )}
                      </>
                    )}

                    {otpSent && !otpVerified && (
                      <div className="otp-verification">
                        <input
                          type="text"
                          className="otp-input"
                          maxLength={6}
                          placeholder="Enter OTP"
                          value={otp}
                          onChange={(e) => setOtp(e.target.value)}
                        />
                        {verifyLoader ? (
                          <button className="otp-button" disabled>
                            <svg
                              className="animate-spin h-5 w-5 mr-3 text-white"
                              xmlns="http://www.w3.org/2000/svg"
                              fill="none"
                              viewBox="0 0 24 24"
                            >
                              <circle
                                className="opacity-25"
                                cx="12"
                                cy="12"
                                r="10"
                                stroke="currentColor"
                                strokeWidth="4"
                              ></circle>
                              <path
                                className="opacity-75"
                                fill="currentColor"
                                d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
                              ></path>
                            </svg>
                          </button>
                        ) : (
                          <button
                            type="button"
                            className="otp-button"
                            onClick={verifyOtp}
                            disabled={!otp}
                          >
                            Verify
                          </button>
                        )}

                        <button
                          type="button"
                          className="otp-link"
                          onClick={sendOtp}
                        >
                          Resend OTP
                        </button>
                        {otpError && (
                          <p className="error-message">{otpError}</p>
                        )}
                      </div>
                    )}

                    {otpVerified && (
                      <p className="otp-success">✅ Email verified</p>
                    )}
                  </div>

                  <button
                    type="submit"
                    className="submit-button"
                    disabled={loading || !otpVerified}
                  >
                    {loading ? "Proceeding..." : "Proceed"}
                  </button>
                </form>
              </div>
            </div>
            <div className="RightImg"></div>
          </div>
        </div>
      </div>
    </>
  );
};
